import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { HttperrorhandlerService } from '../../shared/http/httperrorhandler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CycloneDataService {

  constructor(private http: HttpClient, private errorHandler: HttperrorhandlerService) { }

  getWindData(url) {
    const dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setWindData(data);
          resolve(obj);
        }
      );
    });
    return dataPromise;
  }

  getWaveHeightData(url, options) {
    const dataPromise = new Promise((resolve, reject) => {
      this.http.post(url, options).subscribe(
        data => {
          const obj = this.setWindData(data);
          resolve(obj);
        }
      );
    });
    return dataPromise;
  }

  getHeatMap(url) {
    const dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setMapData(data);
          resolve(obj);
      });
    });
    return dataPromise;
  }

  getWaveHeatMap(url, options) {
    const dataPromise = new Promise((resolve, reject) => {
      this.http.post(url, options).subscribe(
        data => {
          const obj = this.setMapData(data);
          resolve(obj);
      });
    });
    return dataPromise;
  }

  setMapData(data) {
    const obj = {};
    let imageUrl = {};
    const imageBounds = [];
    for (const block of Object.keys(data)) {
      for (const property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  setWindData(data) {
    for (const block of Object.keys(data)) {
      const array = [];
      const obj1 = new Object();
      obj1['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 2,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj1['data'] = data[block]['data1'];
      array[0] = obj1;

      const obj2 = {};
      obj2['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 3,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj2['data'] = data[block]['data2'];
      array[1] = obj2;
      return array;
    }
  }

  getForecastFileTimeStamp(primarySource) {
    const url = ProjConstants.API_URL + ProjConstants.API_MAPPING['CYCLONEFILES'] + '/CYCLONE_' + primarySource;
    const promise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(data => {
        let max = data[primarySource];
        for (const source in data) {
          if (max == undefined || Number(data[source]) > max) {
           max = Number(data[source]);
          }
        }
        resolve(max.toString());
      });
    });
    return promise;
  }

  getHistoricalData(days: any): Observable < any >{
    return this.http.get<any>(ProjConstants.API_URL + 'getLatestHistoricalForecastFiles/CYCLONE_ECMWF/' + days).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getCycloneName(): Observable<any>{
    return this.http.get<any>(ProjConstants.API_URL+"cyclone/getAllCycloneEventName").pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  cycloneImpactAreaHeatmapGeojson(): Observable<any>{
    return this.http.get<any>(ProjConstants.API_URL+"rf/getIMDCycloneData").pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }
}
